import { render, staticRenderFns } from "./CardTicketComment.vue?vue&type=template&id=685558f0&"
import script from "./CardTicketComment.vue?vue&type=script&lang=js&"
export * from "./CardTicketComment.vue?vue&type=script&lang=js&"
import style0 from "./CardTicketComment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports